import { convertDateTimeKeepTimezone } from "@/common/datetime/TimeFunction";
import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";
import {
  IAuthenticationService,
  IDialogModel,
  IDialogService,
  IOrganizationService,
  TokenIAuthenticationService,
  TokenIDialogService,
  TokenIOrganizationService,
} from "@/index";
import { baContainer } from "@/ioc";
import {
  IOutlookAppointmentService,
  TokenIOutlookAppointmentService,
} from "@/out-look/services";
import { RootState } from "@/redux";
import {
  AppointmentByTimeRangeInfo,
  IAppointmentByTimeRangeRequest,
  IFetchResourceRequest,
  ResourceInfo,
} from "@/services/resource-service/entity/ResourceEntity";
import { AxiosResponse } from "axios";
import { v4 } from "uuid";
import { config } from "../../config";
import { ELoadMorePagingDefault } from "./entity/Enums";
import {
  FloorPlanInfo,
  IFetchFloorPlanRequest,
  IFloorPlanInfo,
} from "./entity/FloorplanEntity";
import { IMeetingDetails, MeetingDetails } from "./entity/MeeingEntity";
import { ISessionData } from "./entity/SessionDataEntity";
import { IResourceService } from "./IResourceService";
// import { cloneDeep } from "lodash";

// export const dataResource: any = {
//   "@odata.context": "https://coretest02.southeastasia.cloudapp.azure.com:11015/root/odata/$metadata#Collection(BackendForWeb.Service.ViewModels.Organizations.Resources.ResourceModel)",
//   value: [
//     {
//       "@odata.type": "#BackendForWeb.Service.ViewModels.Organizations.Resources.ResourceModel",
//       guid: "144d2d68-2abe-494d-8aae-79fe24b1fd68",
//       name: "OPC_DEMO_207",
//       displayName: "OPC_DEMO_207",
//       email: "OPC_DEMO_207@aodop.onmicrosoft.com",
//       displayEmail: "OPC_DEMO_207@aodop.onmicrosoft.com",
//       timeZone: "Coordinated Universal Time",
//       location: null,
//     },
//     {
//       "@odata.type": "#BackendForWeb.Service.ViewModels.Organizations.Resources.ResourceModel",
//       guid: "4cc326f9-1590-46fe-8579-a9337a7acf7e",
//       name: "OPC_DEMO_624",
//       displayName: "OPC_DEMO_624",
//       email: "OPC_DEMO_624@aodop.onmicrosoft.com",
//       displayEmail: "OPC_DEMO_624@aodop.onmicrosoft.com",
//       timeZone: "Coordinated Universal Time",
//       location: null,
//     },
//   ],
// };

export class ResourceService implements IResourceService {
  private http: HttpClientNormal = new HttpClientNormal();

  fetchMeetingByDate(
    request: IFetchResourceRequest,
    start: string,
    end: string,
    resourceId: string
  ): Promise<SearchResponse<MeetingDetails>> {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/Calendars('${resourceId}')/Appointments?$filter=(endTime/dateTime ge ${start} and endTime/dateTime lt ${end})`;
    return this.http
      .get(url)
      .then((response: AxiosResponse) => {
        if (response?.data?.value) {
          response.data.value = response.data.value.map(
            (item: IMeetingDetails) => {
              return {
                ...item,
                startTime: {
                  ...item.startTime,
                  dateTime: convertDateTimeKeepTimezone(
                    item.startTime?.dateTime || ""
                  ),
                },
                endTime: {
                  ...item.endTime,
                  dateTime: convertDateTimeKeepTimezone(
                    item.endTime?.dateTime || ""
                  ),
                },
              };
            }
          );
        }
        console.log(response);
        const responseClone = new SearchResponse<MeetingDetails>(
          response,
          MeetingDetails
        );
        responseClone.data.sort((a, b) => {
          const aTime = new Date(a.startTime?.dateTime || "");
          const bTime = new Date(b.startTime?.dateTime || "");
          if (aTime.getTime() > bTime.getTime()) {
            return 1;
          } else if (aTime.getTime() < bTime.getTime()) {
            return -1;
          } else {
            return 0;
          }
        });
        return responseClone;
      })
      .catch(
        (error) =>
          new SearchResponse<MeetingDetails>(error?.response, MeetingDetails)
      );
  }

  fetchMeetingDaysByMonth(
    request: IFetchResourceRequest,
    date: string,
    resourceId: string
  ): Promise<SearchResponse<string>> {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/Calendars('${resourceId}')/AppointmentsByMonth`;

    return this.http
      .post(url, {
        DateTime: date,
      })
      .then((response: AxiosResponse) => {
        const responseClone = new SearchResponse<string>(response);
        responseClone.data = responseClone.data.map(item => convertDateTimeKeepTimezone(item))
        return responseClone;
      })
      .catch((error) => new SearchResponse<string>(error?.response));
  }

  fetchResources(
    request: IFetchResourceRequest
  ): Promise<SearchResponse<ResourceInfo>> {
    const url: string = `${config.API_URL}/${request.tenantId}/Organizations('${request.orgId}')/Resources`;
    const reqBody = {
      ...request.requestBody,
      Page: request.requestBody.Filters?.Page || ELoadMorePagingDefault.Page,
      PageSize:
        request.requestBody.Filters?.PageSize ||
        ELoadMorePagingDefault.PageSize,
      SortQueries: '[{"Code":"Name","Direction":"Ascending"}]',
    };

    return this.http
      .post(url, reqBody)
      .then((response: AxiosResponse) => {
        return new SearchResponse<ResourceInfo>(response, ResourceInfo, true);
      })
      .catch(
        (error) =>
          new SearchResponse<ResourceInfo>(error?.response, ResourceInfo, true)
      );
  }

  toggleSelectResource = (resource: ResourceInfo) => {
    const olAppointmentService: IOutlookAppointmentService =
      baContainer.resolve(TokenIOutlookAppointmentService);
    olAppointmentService.AddResource({
      Resource: resource,
      SelectedResourcesLocation: [resource.displayName],
    });
  };

  toggleRemoveResource = (resource: ResourceInfo) => {
    const olAppointmentService: IOutlookAppointmentService =
      baContainer.resolve(TokenIOutlookAppointmentService);
    olAppointmentService.RemoveResources({
      ResourceEmails: [resource.email],
      SelectedResourcesLocation: [resource.displayName],
    });
  };

  toggleRemoveResources = (resources: ResourceInfo[]) => {
    const olAppointmentService: IOutlookAppointmentService =
      baContainer.resolve(TokenIOutlookAppointmentService);
    olAppointmentService.RemoveResources({
      ResourceEmails: resources.map((item) => item.email),
      SelectedResourcesLocation: resources.map((item) => item.displayName),
    });
  };

  fetchResourcesByEmails = (
    request: IFetchResourceRequest
  ): Promise<SearchResponse<ResourceInfo>> => {
    const url: string = `${config.API_URL}/${request.tenantId}/Organizations('${request.orgId}')/Resources`;
    const reqBody = {
      ...request.requestBody,
      Page: ELoadMorePagingDefault.Page,
      PageSize: 50,
    };
    return this.http
      .post(url, reqBody)
      .then(
        (response: AxiosResponse) =>
          new SearchResponse<ResourceInfo>(response, ResourceInfo, true)
      )
      .catch(
        (error) =>
          new SearchResponse<ResourceInfo>(error?.response, ResourceInfo)
      );
  };

  fetchResourceFloorPlan = (
    request: IFetchFloorPlanRequest
  ): Promise<HttpResponse<FloorPlanInfo>> => {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/ExternalBooking('${request.orgId}')/CheckFloorplanPermission`;
    const requestClone = {
      ...request.requestBody,
      TenantId: request.tenantId,
    };
    return this.http
      .post(url, requestClone)
      .then(
        (response: AxiosResponse<IFloorPlanInfo>) =>
          new HttpResponse<FloorPlanInfo>(response, FloorPlanInfo)
      )
      .catch((error) => new HttpResponse<FloorPlanInfo>(error?.response));
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async onShowFloorPlanDialog(
    currentIndex = 1,
    callback?: (dialog: IDialogModel) => void,
    data?: RootState
  ) {
    const sessionId = v4();
    const authenticationService: IAuthenticationService = baContainer.resolve(
      TokenIAuthenticationService
    );
    const token: string | undefined =
      await authenticationService.GetUserIdentityToken();
      const olOrganizerService: IOrganizationService = baContainer.resolve(
        TokenIOrganizationService
      );
      const organizer = await olOrganizerService.GetCurrentOrganizer();
    const dataSession: ISessionData = {
      orgInfo: data?.orgInfo?.orgInfo?.toJson(),
      outlookInfo: data?.orgInfo?.outlookInfo?.toJson(),
      organizer: data?.orgInfo?.organizer?.toJson(),
      locationTrees: data?.orgInfo?.locationTrees,
      categoryTrees: data?.orgInfo?.categoryTrees,
      selectedResource: (data?.resources?.selectedResource || []).map(
        (item: ResourceInfo) => item.toJson()
      ),
      filterResource: data?.resources?.filterResource,
      settingInfo: JSON.parse(JSON.stringify(data?.settingInfo)),
      locationList: data.orgInfo?.locationList || [],
      token,
      timezone: organizer?.TimeZoneStandardName || ""
    };
    const requestSaveDataSession: ISessionData = dataSession;

    const urlSaveDataSession: string = `${config.API_URL}/sessions/${sessionId}`;

    await this.http.post(urlSaveDataSession, requestSaveDataSession);

    const dialogService: IDialogService =
      baContainer.resolve(TokenIDialogService);

    const dialogUrl = `${config.URL_ENDPOINT}/floorplan?sessionId=${sessionId}`;
    dialogService.ShowDialog(
      dialogUrl,
      {
        Width: 86,
        Height: 86,
      },
      callback
    );
  }

  fetchSessionDataForFloorPlanDialog = (
    sessionId: string
  ): Promise<HttpResponse<ISessionData>> => {
    const urlGetDataSession: string = `${config.API_URL}/sessions/${sessionId}`;
    return this.http
      .get(urlGetDataSession)
      .then((resp: AxiosResponse<{ data: ISessionData }>) => {
        const response = {
          ...resp,
          data: resp.data?.data,
        };
        return new HttpResponse<ISessionData>(response);
      })
      .catch((err) => new HttpResponse(err?.response));
  };

  fetchAppointmentsByTimeRange = (tenantId: string, req: IAppointmentByTimeRangeRequest): Promise<SearchResponse<AppointmentByTimeRangeInfo>> => {
    const url: string = `${config.API_URL}/${tenantId}/AppointmentsByTimeRange`;
    return this.http
      .post(url, req)
      .then(
        (response: AxiosResponse) =>
          new SearchResponse<AppointmentByTimeRangeInfo>(response, AppointmentByTimeRangeInfo, true)
      )
      .catch(
        (error) =>
          new SearchResponse<AppointmentByTimeRangeInfo>(error?.response, AppointmentByTimeRangeInfo)
      );
  }
}
